const RemoveAcronym = (text: string) => {
  const regexAcronym = /\b[A-Z]+\.(?:[A-Z]+\.)+[A-Z]+\b\./g;
  const acronymList = text.match(regexAcronym);

  acronymList?.forEach((acronym) => {
    text = text.replace(acronym, acronym.replaceAll('.', ''));
  });

  return text;
};

export default RemoveAcronym;
